"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCloseButton = void 0;
var _drywall = require("drywall");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CloseButtonMixin = require("../../mixins/components/CloseButtonMixin");
/**
 * An HTML `<button>` element used for closing content such as dialogs.
 *
 * @since 7.4.0
 */
var StyledCloseButton = /*#__PURE__*/(0, _styledComponents.default)(_drywall.CloseButton).withConfig({
  displayName: "StyledCloseButton",
  componentId: "c11n-8-107-0__sc-107ty8u-0"
})(["", ""], _CloseButtonMixin.CloseButtonMixin);
exports.StyledCloseButton = StyledCloseButton;